import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eNhomCauHoiActionIds,
  INhomCauHoiActionTypes,
} from "../../action-types/cau-hoi/INhomCauHoiActions";
import { nhomCauHoiApi } from "../../../api/cau-hoi/nhomCauHoiApi";
import { ISMT_NhomCauHoi } from "../../../model/respone/cau-hoi/ISMT_NhomCauHoi";
import { ISMT_NhomCauHoi_MucTriNang } from "../../../model/respone/cau-hoi/ISMT_NhomCauHoi_MucTriNang";
import { INhomCauHoiProgressRequest } from "../../../model/request/nhom-cau-hoi/INhomCauHoiProgressRequest";
import { cauHoiApi } from "../../../api/cau-hoi/cauHoiApi";

export function* nhomCauHoiSaga(): any {
  yield takeLatest(eNhomCauHoiActionIds.LOAD_START, loadWorker);
  yield takeLatest(eNhomCauHoiActionIds.DELETE_START, deleteWorker);
  yield takeLatest(eNhomCauHoiActionIds.SAVE_START, saveWorker);
  yield takeLatest(eNhomCauHoiActionIds.LOAD_BY_ID_START, loadByIdWorker);
  yield takeLatest(eNhomCauHoiActionIds.IMPORT_START, importWorker);
  yield takeLatest(eNhomCauHoiActionIds.PROGRESS_START, progressWorker);
  yield takeLatest(eNhomCauHoiActionIds.SYNC_VNPT_START, syncVNPTWorker);
  yield takeLatest(
    eNhomCauHoiActionIds.SAVE_MUCTRINANG_START,
    saveMucTriNangWorker
  );
  // yield takeLatest(
  //   eNhomCauHoiActionIds.SEARCH_BY_NHOM_CAU_HOI_ID_START,
  //   searchByIdNhomCauHoiWorker
  // );
  yield takeLatest(
    eNhomCauHoiActionIds.DELETE_BO_CAU_HOI_START,
    deleteBoCauHoiWorker
  );
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(nhomCauHoiApi.SelectVmAll);
  if (res.is_success) {
    yield put(rootActions.cauHoi.nhomCauHoi.LOAD_SUCCESS(res.data));
  } else {
    yield put(rootActions.cauHoi.nhomCauHoi.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* loadByIdWorker(action: INhomCauHoiActionTypes): any {
  const res: IBaseRespone = yield call(
    nhomCauHoiApi.SelectById,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.cauHoi.nhomCauHoi.LOAD_BY_ID_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.cauHoi.nhomCauHoi.LOAD_BY_ID_ERR(res.message ?? "Có lỗi")
    );
  }
}

function* saveWorker(action: INhomCauHoiActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as ISMT_NhomCauHoi;
  if (payload.id > 0) {
    res = yield call(nhomCauHoiApi.Update, payload);
  } else {
    res = yield call(nhomCauHoiApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.cauHoi.nhomCauHoi.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.cauHoi.nhomCauHoi.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* deleteWorker(action: INhomCauHoiActionTypes): any {
  const res: IBaseRespone = yield call(
    nhomCauHoiApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.cauHoi.nhomCauHoi.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.cauHoi.nhomCauHoi.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* importWorker(action: INhomCauHoiActionTypes): any {
  const res: IBaseRespone = yield call(
    nhomCauHoiApi.Import,
    action.payload as FormData
  );
  if (res.is_success) {
    yield put(rootActions.cauHoi.nhomCauHoi.IMPORT_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.cauHoi.nhomCauHoi.IMPORT_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* saveMucTriNangWorker(action: INhomCauHoiActionTypes): any {
  let res: IBaseRespone;
  res = yield call(
    nhomCauHoiApi.InsertMucTriNang,
    action.payload as unknown as ISMT_NhomCauHoi_MucTriNang[]
  );
  if (res) {
    if (res.is_success) {
      yield put(
        rootActions.cauHoi.nhomCauHoi.SAVE_MUCTRINANG_SUCCESS(res.data)
      );
    } else {
      yield put(
        rootActions.cauHoi.nhomCauHoi.SAVE_MUCTRINANG_ERROR(
          res.message ?? "Có lỗi"
        )
      );
    }
  }
}

// function* searchByIdNhomCauHoiWorker(action: INhomCauHoiActionTypes): any {
//   const res: IBaseRespone = yield call(
//     nhomCauHoiApi.SelectIdNhomCauHoi,
//     action.payload as number
//   );
//   if (res.is_success) {
//     yield put(
//       rootActions.cauHoi.nhomCauHoi.SEARCH_BY_NHOM_CAU_HOI_ID_SUCCESS(res.data)
//     );
//   } else {
//     yield put(
//       rootActions.cauHoi.nhomCauHoi.SEARCH_BY_NHOM_CAU_HOI_ID_ERROR(
//         res.message ?? "Có lỗi"
//       )
//     );
//   }
// }

function* deleteBoCauHoiWorker(action: INhomCauHoiActionTypes): any {
  const res: IBaseRespone = yield call(
    nhomCauHoiApi.DeleteBoCauHoi,
    action.payload as any
  );
  if (res.is_success) {
    yield put(
      rootActions.cauHoi.nhomCauHoi.DELETE_BO_CAU_HOI_SUCCESS(res.data)
    );
  } else {
    yield put(
      rootActions.cauHoi.nhomCauHoi.DELETE_BO_CAU_HOI_ERROR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* progressWorker(action: INhomCauHoiActionTypes): any {
  const res: IBaseRespone = yield call(
    nhomCauHoiApi.Progress,
    action.payload as INhomCauHoiProgressRequest
  );
  if (res.is_success) {
    yield put(rootActions.cauHoi.nhomCauHoi.PROGRESS_SUCCESS(undefined));
    yield put(rootActions.cauHoi.cauHoi.CHANGE_REQUEST({}));
  } else {
    yield put(
      rootActions.cauHoi.nhomCauHoi.PROGRESS_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* syncVNPTWorker(action: INhomCauHoiActionTypes): any {
  const res: IBaseRespone = yield call(cauHoiApi.SyncVNPT);
  if (res.is_success) {
    yield put(rootActions.cauHoi.nhomCauHoi.SYNC_VNPT_SUCCESS(undefined));
  } else {
    yield put(
      rootActions.cauHoi.nhomCauHoi.SYNC_VNPT_ERROR(res.message ?? "Có lỗi")
    );
  }
}
